import { Monitor } from "../../../../types/assessment/monitor.ts";
import {
  partialGrantFixGenerator,
  unusedGrantFixGenerator,
  unusedPermissionSetFixGenerator,
} from "./aws-fix-generators.ts";

export const AwsGrantPresets = {
  "Unused AWS Policy Assignments": Monitor({
    show: "grant",
    scopes: ["aws"],
    searchTerm:
      'usage:type:"unused" ^usage:type:!"unused" ^grant=isProviderManaged:"true" identity=status:"active"',
    label: "Unused AWS policy assignment",
    priority: "HIGH",
    cta: "No privileges given by this policy assignment have been used in the last 90 days. Consider removing this policy assignment.",
    remediation: (action: string) =>
      `No privileges given by this policy assignment have been used in the last 90 days. P0 has automatically ${action} to remove this policy assignment.`,
    description:
      "Policy assignments for which no actions have been used in the last 90 days.",
    fix: unusedGrantFixGenerator,
  }),
  "Unused AWS Permission Set Assignments": Monitor({
    show: "grant",
    scopes: ["aws"],
    searchTerm: 'permissionSet: ^usage:type:!"unused"',
    label: "Unused AWS permission set",
    priority: "HIGH",
    cta: "Actions granted by this permission-set assignment have not been used in the last 90 days. Consider removing this assignment.",
    description:
      "Permission sets for which no actions have been used in the last 90 days.",
    fix: unusedPermissionSetFixGenerator,
  }),
  "Excessive AWS Policies": Monitor({
    scopes: ["aws"],
    show: "grant",
    // nodes that can reach an unused permission AND can reach a used or unknown permission
    searchTerm:
      'usage:type:"unused" usage:type:!"unused" ^grant=isProviderManaged:"true"',
    label: "Excessive AWS policies",
    priority: "MEDIUM",
    cta: "This grant has more privileges than are required for its intended use. Consider replacing this grant with a least-privileged role.",
    description:
      "Grants with more privileges than are required for their intended use.",
    fix: partialGrantFixGenerator,
  }),
  "Privileged AWS Policies": Monitor({
    scopes: ["aws"],
    show: "grant",
    searchTerm: 'risk:"CRITICAL" ^grant=isProviderManaged:"true"',
    label: "Privileged AWS policies",
    priority: "MEDIUM",
    cta: "This policy allows access with critical risks. Consider replacing this policy with a low-sensitivity policy, and using just-in-time access for ephemeral access.",
    description: "Policies with any privileges that allow sensitive access.",
  }),
  "AWS Policies with Unused Privileged Access": Monitor({
    scopes: ["aws"],
    show: "grant",
    searchTerm:
      'usage:type:"unused"->risk:"CRITICAL" ^grant=isProviderManaged:"true"',
    label: "AWS policies with unused privileged access",
    priority: "CRITICAL",
    cta: "This policy conveys privileges that allow critical risks, and these privileges have not been used in the last 90 days. Consider replacing this policy with a policy that does not include these privileges.",
    description: "Policies with unused privileges that allow sensitive access.",
    fix: partialGrantFixGenerator,
  }),
};
